"use client";

import { useEffect } from "react";

export function HashNavigator() {
  useEffect(() => {
    // Check if there's a hash in the URL
    if (typeof window !== "undefined" && window.location.hash) {
      const hash = window.location.hash;
      const element = document.querySelector(hash);

      if (element) {
        // Wait for the page to fully load, then scroll to the section
        setTimeout(() => {
          const headerHeight = 80; // Approximate height of sticky header
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition =
            elementPosition + window.pageYOffset - headerHeight;

          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
          });
        }, 100);
      }
    }
  }, []);

  return null; // This component doesn't render anything
}
